import { AxiosResponse } from 'axios';
import { call, put } from 'redux-saga/effects';
import api from '../../Axios/middleware';
import { failureGetTariff, successGetTariff } from './TariffSlicer';
import { ITariffList } from '../../../Pages/Tariff/ITariff';
import { PayloadAction } from '@reduxjs/toolkit';
import { failureAddTariff, successAddTariff } from './AddTariffSlicer';
import { failureUpdateTariff, successUpdateTariff } from './UpdateTariffSlicer';
import { failureDeleteTariff, successDeleteTariff } from './DeleteTariffSlice';

const TariffApi = (action: PayloadAction<any>) => {
  return api.get(`/tariff/location/${action.payload}`);
};

export function* TariffCall(action: PayloadAction<number>) {
  try {
    const response: AxiosResponse = yield call(TariffApi, action);
    yield put(successGetTariff(response.data));
  } catch (error) {
    yield put(failureGetTariff(error));
  }
}

// add Tariff
const AddTariffApi = (action: PayloadAction<ITariffList>) => {
  return api.post('/tariff/create', action.payload);
};

export function* AddTariffCall(action: PayloadAction<ITariffList>) {
  try {
    const response: AxiosResponse = yield call(AddTariffApi, action);
    yield put(successAddTariff(response.data));
  } catch (error) {
    yield put(failureAddTariff(error));
  }
}

// update Tariff
const UpdateTariffApi = (action: PayloadAction<ITariffList>) => {
  // console.log(action.payload);

  return api.patch(`/tariff/${action.payload.id}`,action.payload);
};

export function* UpdateTariffCall(action: PayloadAction<ITariffList>) {
  try {
    const response: AxiosResponse = yield call(UpdateTariffApi, action);
    yield put(successUpdateTariff(response.data));
  } catch (error) {
    yield put(failureUpdateTariff(error));
  }
}

// delete Tariff
const DeleteTariffApi = (action: PayloadAction<number>) => {
  return api.delete(`/tariff/${action.payload}`);
};
export function* DeleteTariffCall(action: PayloadAction<number>) {
  try {
    const response: AxiosResponse = yield call(DeleteTariffApi, action);
    yield put(successDeleteTariff(response.data));
  } catch (error) {
    yield put(failureDeleteTariff(error));
  }
}
